module.exports = " <input type=\"number\" inputmode=\"numeric\" class=\"select-page\" ng-model=\"inputPage\" ng-change=\"selectPage(inputPage)\"> ";


//////////////////
// WEBPACK FOOTER
// ./src/app/core/directive/dv-pagination/dv-pagination.html
// module id = NmJP
// module chunks = 0